import axios from 'axios';

const API_BASE_URL = '/api';

class FacilityService {
  async getAllFacilities() {
    try {
      const response = await axios.get(`${API_BASE_URL}/facilities/`);
      return response.data;
    } catch (error) {
      console.error('Error fetching facilities:', error);
      throw error;
    }
  }

  async getFacilityById(id) {
    try {
      const response = await axios.get(`${API_BASE_URL}/facilities/${id}`);
      return response.data;
    } catch (error) {
      console.error('Error fetching facility:', error);
      throw error;
    }
  }

  async createFacility(facilityData) {
    try {
      const response = await axios.post(`${API_BASE_URL}/facilities/`, facilityData);
      return response.data;
    } catch (error) {
      console.error('Error creating facility:', error);
      throw error;
    }
  }

  async updateFacility(id, facilityData) {
    try {
      const response = await axios.put(`${API_BASE_URL}/facilities/${id}`, facilityData);
      return response.data;
    } catch (error) {
      console.error('Error updating facility:', error);
      throw error;
    }
  }

  async deleteFacility(id) {
    try {
      await axios.delete(`${API_BASE_URL}/facilities/${id}`);
    } catch (error) {
      console.error('Error deleting facility:', error);
      throw error;
    }
  }

  async pairReader(id, { pairing_code, name }) {
    try {
      const response = await axios.post(`${API_BASE_URL}/facilities/${id}/pair-reader`, { pairing_code, name });
      return response.data;
    } catch (error) {
      console.error('Error pairing reader:', error);
      throw error;
    }
  }

  async getReaderStatus(id) {
    try {
      const response = await axios.get(`${API_BASE_URL}/facilities/${id}/reader-status`);
      return response.data;
    } catch (error) {
      console.error('Error fetching reader status:', error);
      throw error;
    }
  }
}

export default new FacilityService();